import { Box, Card, CardContent, CardHeader, Skeleton, Typography } from "@mui/material";
import Decimal from 'decimal.js';
import { formatCurrency } from "../../helpers/financialHelpers";

const InvoiceResumeCard = ({ partsValue, worksValue, discountAmount, installmentsQty, loading }) => {
    const subtotal = new Decimal(partsValue).plus(worksValue);
    const totalValue = subtotal.minus(discountAmount || 0);
    
    return (
        <>
            <Card sx={{ p: '1.5rem', minWidth: '23rem', bgcolor: 'background.header', display: 'flex', flexDirection: 'column' }}>
                <CardHeader
                    title={
                        <Typography variant="h5">Resumo da fatura</Typography>
                    }
                />
                <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <Box>
                        <Box>
                            <Typography variant="body1">Subtotal Peças e Materiais </Typography>
                            {loading ? <Skeleton width={80} /> : <Typography>R$ {formatCurrency(partsValue)}</Typography>}
                            <Typography variant="body1">Subtotal Serviços</Typography>
                            {loading ? <Skeleton width={80} /> : <Typography>R$ {formatCurrency(worksValue)}</Typography>}
                        </Box>
                    </Box>
                    {discountAmount > 0 && (
                        <Box>
                            <Typography variant="body2" sx={{ color: 'error.main' }}>Desconto</Typography>
                            {loading ? <Skeleton width={80} /> : <Typography sx={{ color: 'error.main' }}>R$ {formatCurrency(discountAmount)}</Typography>}
                        </Box>
                    )}
                    <Box>
                        <Typography variant="h6" sx={{ color: 'primary.main' }}>Total</Typography>
                        {loading ? <Skeleton width={100} /> : <Typography variant="h6" sx={{ color: 'primary.main' }}>R$ {formatCurrency(totalValue)}</Typography>}
                    </Box>
                    {installmentsQty > 1 && (
                        <Box>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>Parcelado em {installmentsQty}x</Typography>
                        </Box>
                    )}
                </CardContent>
            </Card>
        </>
    )
};

export default InvoiceResumeCard;